import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CommonSearch from "../../components/ui/CommonSearch/CommonSearch.jsx";
import { Link, useLocation } from 'react-router-dom';
import { BackarrowIcon } from "../../assets/Svg/SvgImages.jsx";
import SnigleWalletTable from "./SnigleWalletTable/SnigleWalletTable.jsx";
import { ATS } from '../../features/ats/atsSlice';
import { useDebounce } from "../../hooks/useDebounce";
const PortfolioSingleWallet = props => {
  const limit = 2;
  const [pageNumber, setpageNumber] = useState(1);
  const [searchText, setsearchText] = useState('');
  const location = useLocation();
  const dispatch = useDispatch();
  const [walletAssetData, setWalletAssetData] = useState([]);
  const debounced = useDebounce(searchText, 500);
  const locationState = location.state ?? {};
  const wallet_id = locationState.wallet_id ?? locationState.walletId;
  const vault_id = locationState.vault_id ?? locationState.vaultId ?? locationState.enterprisesId ?? locationState.enterpriseId;
  const wallet_name = locationState.wallet_name ?? locationState.walletName ?? '';
  const getWalletAssetData = async () => {
    if (wallet_id == null || vault_id == null) return;
    const param = {
      walletId: wallet_id,
      vaultId: vault_id,
      pageNumber: pageNumber,
      limit: limit
    };
    if (searchText !== '') {
      param.searchText = searchText;
    }
    let result = await dispatch(ATS.fetchWalletAssetList(param));
    if (result.status === 200) {
      setWalletAssetData(result.data);
    }
  };
  const handleSearch = e => {
    setsearchText(e.target.value);
    setpageNumber(1);
  };
  useEffect(() => {
    getWalletAssetData();
  }, [pageNumber, debounced]);
  if (wallet_id == null || vault_id == null) {
    return <div className='portfolioSinglewallet'>
                <div className='commonCardbox'>
                    <div className='backBtn'>
                        <Link to="/portfolio"><span><BackarrowIcon /></span> Back</Link>
                    </div>
                    <p className="mt-4">Wallet details could not be loaded (missing wallet or enterprise reference).</p>
                </div>
            </div>;
  }
  return <>
            <div className='portfolioSinglewallet'>
                <div className='commonCardbox'>
                    <div className='backBtn'>
                        <Link to="/portfolio"><span><BackarrowIcon /></span> Back</Link>
                    </div>
                    <div className='mb-4 mb-md-5'>
                        <div className='dashHeading'>
                            <h3>{wallet_name ?? ''}<span className='ms-md-4'>{wallet_id ?? ''}</span></h3>
                        </div>
                        <CommonSearch className="walletSearch" placeholder="Search" onChange={e => {
            handleSearch(e);
          }} />
                    </div>
                    <SnigleWalletTable walletAssetData={walletAssetData} pageNumber={pageNumber} limit={limit} setpageNumber={setpageNumber} />
                </div>
            </div>
        </>;
};
export default PortfolioSingleWallet;